import React from "react";

import {
  Stack,
  CheckboxProps,
  FormControlLabel,
  Typography,
} from "@mui/material";

import { DefaultBadge, RecommendedBadge } from "@rui/Badge";
import Checkbox from "@rui/Checkbox";
import TooltipWrapper from "@rui/TooltipWrapper";

interface SettingCheckboxProps extends CheckboxProps {
  isDefault?: boolean;
  label?: string;
  recommended?: boolean;
  onChange: (
    event: React.ChangeEvent<HTMLInputElement>,
    checked: boolean
  ) => void;
  tooltip?: string;
}

const SettingCheckbox = ({
  isDefault,
  label,
  recommended,
  tooltip,
  ...props
}: SettingCheckboxProps) => {
  return (
    <Stack direction="row" alignItems="center">
      <TooltipWrapper arrow placement="right" title={tooltip}>
        <FormControlLabel
          control={<Checkbox {...props} sx={{ mr: 1.5, ...props.sx }} />}
          label={
            <Typography
              variant="bodySecondaryReg"
              sx={{ color: "shades.neutral.700" }}
            >
              {label}
            </Typography>
          }
        />
      </TooltipWrapper>
      {recommended && <RecommendedBadge />}
      {isDefault && <DefaultBadge />}
    </Stack>
  );
};
export default SettingCheckbox;
